import {
	theActionSvg,
	theBigBashLogoAnimationSvg1,
	theBigBashLogoAnimationSvg2,
	theBigBashLogoSvg,
	theBrainSvg,
	theSkillsSvg
} from "@/assets/images/svgFiles";
import { sharedStyles } from "@lib/sharedStyles";
import { LitElement, TemplateResult, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";

@customElement("default-display-component")
export class DefaultDisplayComponent extends LitElement {
	static override styles = [
		sharedStyles,
		css`
			.svg-container {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100vh;
				height: 80vh;
				overflow: hidden;
			}

			.svg-element {
				display: block;
				max-height: 100%;
				max-width: 100%;
				width: auto;
				height: auto;
			}

			@keyframes pulse {
				0%, 100% {
					opacity: 0.8;
				}
				50% {
					opacity: 1;
				}
			}

			.animated {
				animation: pulse 2s ease-in-out infinite;
			}
		`,
	];

	@property({ type: String }) roomId: string = "skills";
	@state() private currentSvgIndex = 0;

	private rotationInterval: number | undefined;

	private get svgElements(): TemplateResult[] {
		let base: TemplateResult[] = [theBigBashLogoSvg, theBigBashLogoAnimationSvg1, theBigBashLogoAnimationSvg2];

		switch (this.roomId) {
			case "skills":
				return [theSkillsSvg, ...base];
			case "brain":
				return [theBrainSvg, ...base];
			case "action":
				return [theActionSvg, ...base];
			default:
				return [theActionSvg, theBrainSvg, theSkillsSvg, ...base];
		}
	}

	connectedCallback() {
		super.connectedCallback();
		this.startSvgRotation();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		if (this.rotationInterval) clearInterval(this.rotationInterval);
	}

	private startSvgRotation() {
		this.rotationInterval = window.setInterval(() => {
			this.currentSvgIndex =
				(this.currentSvgIndex + 1) % this.svgElements.length;
			this.requestUpdate();
		}, 5000);
	}

	render() {
		return html`
      <div class="svg-container">
        ${this.svgElements[this.currentSvgIndex]}
      </div>
    `;
	}
}

export default DefaultDisplayComponent;
